import commonUrlConfig from "@adapters/infrastructures/urlConfig/Reports/commonApiUrl";
class ExtPlatDataRetrieveRepo {
    constructor(http) {
        this.http = http;
    }
    async retriveAccountData(token) {
        // console.log("token", token);
        const url = new URL(commonUrlConfig.retriveAccountData);
        const payload = { token: token };
        const retrieveData = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: payload,
        });
        if (retrieveData.data &&
            retrieveData.data.value &&
            retrieveData.data.value !== null)
            return retrieveData.data.value;
        else
            return "";
    }
    async retrieveExtPlatAccData() {
        const url = new URL(commonUrlConfig.retrieveExtPlatAccData);
        const retrieveData = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        if (retrieveData.data &&
            retrieveData.data.lgnData &&
            retrieveData.data.lgnData !== null)
            return JSON.stringify(retrieveData.data.lgnData);
        else
            return "";
    }
}
export default ExtPlatDataRetrieveRepo;
